
class TriggerSetAttributes {

	constructor( triggerEl ) {
		this.triggerEl = triggerEl;
		this.triggerEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			this.setAttributes()
		} );
	}

	setAttributes() {

		const attributesData = JSON.parse( this.triggerEl.dataset.setAttributesType );
		const scopeSelector = this.triggerEl.dataset.setAttributesScope;

		// There are two modes:
		// Scoped: Get the closest container element and only update elements inside the scope.
		// Unscoped: Update all elements with the same target in global context.
		let triggerEls = [ this.triggerEl ];
		if ( scopeSelector ) {
			const scopeEl = this.triggerEl.closest( scopeSelector );
			triggerEls = Array.from( scopeEl.querySelectorAll( '[data-set-attributes]' ) ).filter( triggerEl => triggerEl.dataset.setAttributesScope === scopeSelector );
		}

		triggerEls.forEach( triggerEl => {

			const targetSelector = triggerEl.dataset.setAttributesTarget;

			const scopeEl = scopeSelector ? triggerEl.closest( scopeSelector ) : document;
			const targetEls = scopeEl.querySelectorAll( targetSelector );

			// Set type="text" or any other attribute on the target element.
			targetEls.forEach( targetEl => {
				Object.entries( attributesData ).forEach( ( [key, val] ) => {
					targetEl.setAttribute( key, val );
				} );
			} );

			// Update all relevant Buttons to show the new state.
			const otherTriggerEls = Array.from( scopeEl.querySelectorAll( '[data-set-attributes]' ) ).filter( otherTriggerEl => otherTriggerEl.dataset.setAttributesTarget === targetSelector );
			otherTriggerEls.forEach( otherTriggerEl => {
				const isActive = otherTriggerEl.classList.contains( 'en_is_active' );
				otherTriggerEl.classList.toggle( 'en_is_active', ! isActive );
				otherTriggerEl.classList.toggle( 'en_is_inactive', isActive );
			} )
		} );
	}
}

const initTriggerSetAttributes = function( scopeEl = document ) {
	scopeEl.querySelectorAll( '[data-set-attributes]' ).forEach( setAttributesEl => {
		// Only init once per element - even if the function is called multiple times.
		setAttributesEl.EN_TriggerSetAttributes ??= new TriggerSetAttributes( setAttributesEl );
	} );
}

export {
	TriggerSetAttributes as default,
	initTriggerSetAttributes
};
